import { AbstractControl } from '@angular/forms';
import { ControlPredicateFn } from './angular-forms.types';

function controlValueSelector(predicate: ControlPredicateFn) {
  return <T, F = any>(select: (controlValue: F) => T) =>
    (ctrl: AbstractControl, fallback: () => T) =>
      predicate(ctrl, []) ? select(ctrl.value as unknown as F) : fallback();
}

/**
 * Helper function for selecting the value of an AbstractControl
 * if it is enabled, or a fallback value otherwise
 *
 * @param select
 * Function that is called with the control value for an enabled
 * control.
 *
 * @returns
 * A function that when called with an `AbstractControl` will
 * either call
 * - `select` function with the value of the control
 * - `fallback` function if the control is disabled
 *
 * @example
 * const toString = (v) => `${v}`
 * const stringifyCtrlValue = enabledControlSelector(toString);
 *
 * const ctrl1 = new FormControl(1);
 * // will call `toString(1)`
 * stringifyCtrlValue(ctrl1, () => false)
 *
 * control ctrl2 = newFormControl(2);
 * ctrl2.disable();
 * // will call `() => false`
 * stringifyCtrlValue(ctrl2, () => false)
 */
export const enabledControlSelector = controlValueSelector(
  (ctrl) => !ctrl.disabled,
);
